import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'inbox', en);
i18next.addResources('fr', 'inbox', fr);

declare global {
  interface RegisteredLocales {
    inbox: typeof en;
  }
}
